import { createSelector } from 'reselect';
import getModuleState from './moduleStateSelector';

export const getForm = createSelector(
  getModuleState,
  (moduleState) => moduleState.get('form')
);

export const getIsSubmitted = createSelector(
  getForm,
  (state) => state.get('isSubmitted')
);
